import CryptoJS from 'crypto-js';

/**
 * Encripta texto plano (string) usando AES con key en Base64.
 * Regresa el formato "ivBase64:cipherTextBase64" (mismo formato que ya usas en decryptData).
 */
export function encryptData(plainText: string, keyBase64: string): string {
  const key = CryptoJS.enc.Base64.parse(keyBase64);
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(plainText, key, { iv });

  const ivBase64 = CryptoJS.enc.Base64.stringify(iv);
  const cipherTextBase64 = encrypted.toString();

  return `${ivBase64}:${cipherTextBase64}`;
}
